module.exports = __webpack_public_path__ + "img/cloth_g2_sleeve_15.4a169fcd.svg";